const REMOVE_PROJECT_LINK_SET_FOCUSED_LINK =
  "REMOVE_PROJECT_LINK_SET_FOCUSED_LINK";
const REMOVE_PROJECT_LINK_RESET_DATA = "REMOVE_PROJECT_LINK_RESET_DATA";

export default {
  REMOVE_PROJECT_LINK_SET_FOCUSED_LINK,
  REMOVE_PROJECT_LINK_RESET_DATA,
};
